import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/PageContent.tsx");
